<template>
  <a-modal
    title="订单详情"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :footer="false"
    @cancel="handleCancel"
    v-if="hackReset"
  >
    <div class="viewDetial-tiem">
			<div class="viewDetial-title">患者信息</div>
			<a-row style="height:30px">
				<a-col :span="12">
					<label style="padding-left:28px">姓名：{{this.userDate.patientName}}</label>
				</a-col>
				<a-col :span="12">
					<label style="padding-left:28px">科室：{{this.userDate.deptName}}</label>
				</a-col>
			</a-row>
			<a-row style="height:30px">
				<a-col :span="12">
					<label  style="padding-left:15px">手机号：{{this.userDate.patientMobile}}</label>
				</a-col>
				<a-col :span="12">
					<label>就诊医生：{{this.userDate.regDrName}}</label>
				</a-col>
			</a-row>
		</div>
		<div class="viewDetial-tiem">
      <div class="viewDetial-title">订单信息</div>
			<a-row style="height:30px">
				<a-col :span="12">
					<label>订单编号：{{this.userDate.orderCode}}</label>
				</a-col>
				<a-col :span="12">
					<label>订单类型：{{ this.userDate.treatType == '0'? '图文问诊' : this.userDate.treatType == '1'? '健康咨询' : this.userDate.treatType == '2'? '视频问诊' : ''  }}</label>
				</a-col>
			</a-row>
			<a-row style="height:30px">
				<a-col :span="12">
					<label>创建时间：{{this.userDate.createTime}}</label>
				</a-col>
				<a-col :span="12">
					<label style="padding-left:28px">状态：{{ this.userDate.orderState == '0'? '待支付' : this.userDate.orderState == '2'? '已支付' : this.userDate.orderState == '4'? '已取消' : '' }}</label>
				</a-col>
			</a-row>
      <a-row style="height:30px">
				<a-col :span="12">
					<label>支付时间：</label>{{this.userDate.payTime}}
				</a-col>
				<a-col :span="12">
					<label>实际支付：{{this.userDate.totalFee == 'undefined' ? '' : this.userDate.totalFee}}元</label>
				</a-col>
			</a-row>
    </div>
  </a-modal>
</template>

<script>
  import { recipeDetial } from '@/api/modular/interhospital/inquiryorder/inquiryorderManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        ctstampDateString: '',
        birthdayDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this),
        parameter : {},
        userDate : '',
        hackReset : true,
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.parameter.id = record.orderId;
        this.visible = true;
        recipeDetial(this.parameter).then(res=>{
          this.userDate = res.data;
          console.log(this.userDate)
        });
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
</style>
